import { create } from "zustand"

type UploadState = {
  sessionId: string
  totalFiles: number
  isUploading: boolean
}

type ParserUploadStore = {
  uploadState: UploadState | null
  startUpload: (sessionId: string, totalFiles: number) => void
  uploadComplete: () => void
  uploadFailed: () => void
  reset: () => void
  isUploadingForSession: (sessionId: string | null) => boolean
}

export const useParserUploadStore = create<ParserUploadStore>((set, get) => ({
  uploadState: null,

  startUpload: (sessionId, totalFiles) => {
    set({
      uploadState: {
        sessionId,
        totalFiles,
        isUploading: true,
      },
    })
  },

  uploadComplete: () => {
    set({ uploadState: null })
  },

  uploadFailed: () => {
    set({ uploadState: null })
  },

  reset: () => {
    set({ uploadState: null })
  },

  isUploadingForSession: (sessionId) => {
    const state = get().uploadState
    if (!state || !sessionId) return false
    return state.isUploading && state.sessionId === sessionId
  },
}))
